/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPerformanceIndicatorsQuery } from '../../models/get-performance-indicators-query';
import { GetPerformanceIndicatorsQueryResult } from '../../models/get-performance-indicators-query-result';

export interface ApiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Params {
      body?: GetPerformanceIndicatorsQuery
}

export function apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost(http: HttpClient, rootUrl: string, params?: ApiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPerformanceIndicatorsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPerformanceIndicatorsQueryResult>;
    })
  );
}

apiPerformanceIndicatorGetProjectsPerformanceIndicatorsPost.PATH = '/api/PerformanceIndicator/GetProjectsPerformanceIndicators';
